<template>
  <div
    class="bg-white p-8 rounded border border-solid border-gray-200"
    :class="pt?.root"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  pt?: {
    root?: string
  }
}>()
</script>
